import {PoweroffOutlined, SettingOutlined} from '@ant-design/icons';
import {Badge, Button, Col, Menu, message, Row, Steps, Modal, Tooltip, Icon} from 'antd';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link} from 'react-router-dom';
import {progressStage, specimenType} from "../../utils/const";
import {isNull, notNull, openEndPoint} from "../../utils/utils";
import {scanPageSelector, systemStateNotificationHandler} from "../../utils/scanner_utils";
import {stopScannerServer} from "../../utils/device_utils"
import {get, get_response} from "../../helper/request";
import {aclPermissions, hasPermissions} from "../../const/ACLPermissions";
import "../../asset/style/scanner/scanner.css"
import {updateIsCassetteEjecting} from "../../redux_actions/scanWorkflow.action";
import cookie from 'react-cookies';import {store} from "../../helper/store";
import {error_manager} from "../../helper/error_manager";

const { Step } = Steps;

class ScannerTimeline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            percentCompleted: 10,
            isScanning: false,
            modalVisible: false,
            currPreviewStatus: null,
        }
        this.usbConnectionCodeDict = {
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED",
            INITIALISED : "INITIALISED", 
            ERRORED : "ERRORED", 
            DOES_NOT_EXIST: "DOES_NOT_EXIST",
            UNKNOWN: "UNKNOWN"
        }
        this.hardwareDict = {
            CAMERA : "Camera", 
            SERIAL : "Serial", 
            PREVIEW_CAMERA : "Preview Camera",
            UPS: "UPS",
            POWER: "Power"
        }
        this.powerStatusDict = {
            UNKNOWN : "UNKNOWN",
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED",
            ONLINE: "ONLINE",
            ONBATT: "ONBATT"
        }
        this.systemStateDict = {
            CRITICAL : "CRITICAL",
            WARNING : "WARNING",
            AVAILABLE : "AVAILABLE"
        }
        this.notificationTypeDict = {
            HDD : 'hdd', 
            SSD : 'ssd', 
            STOP : 'stop'
        }
    }
    componentDidUpdate = () => {
        this.deviceStatusChecks();
    }

    deviceStatusChecks = () => {
        let allUsbDevicesConnected = true;
        let scannerStatus = (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {});
        let usbDependenciesStatus = (scannerStatus || {}).usbDependenciesStatus;
        let upsPowerStatus = ((scannerStatus || {}).upsPowerStatus || {});
        let powerStatus = ((scannerStatus || {}).powerStatus || {});
        let upsMandatory = ((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {}).usbDependenciesStatus || {}).upsStatus !== this.usbConnectionCodeDict.DOES_NOT_EXIST;
        let systemState = ((scannerStatus || {}).systemState || {});
        let isCriticalDisk = systemState.ssdStatus == this.systemStateDict.CRITICAL || systemState.hddStatus == this.systemStateDict.CRITICAL;
        let isMorpheusReachable = ((this.props.deviceStatus || {}).scanner_health || {}).device_name != undefined;
        let isServerReachable = ((this.props.deviceStatus || {}).scanner_health || {}).server_up;
        isServerReachable = isServerReachable == undefined ? true : isServerReachable;
        let hardwareError = false;
        let stageEncoderFailure = scannerStatus.stageEncoderFailure;

        if (usbDependenciesStatus != undefined) {
            for (let key in usbDependenciesStatus) {
                if (usbDependenciesStatus[key] != this.usbConnectionCodeDict.INITIALISED && key != 'upsStatus') {
                    hardwareError = true;
                }
                if (usbDependenciesStatus[key] != this.usbConnectionCodeDict.INITIALISED && 
                    usbDependenciesStatus[key] != this.usbConnectionCodeDict.CONNECTED && key != 'upsStatus') {
                    allUsbDevicesConnected = false;
                }
            }
            
            if (upsMandatory) {
                if(upsPowerStatus.deviceStarted == false && upsPowerStatus.powerStatus == this.powerStatusDict.ONBATT) {
                    allUsbDevicesConnected = false;
                }
                
                if(upsPowerStatus.deviceStarted == false && usbDependenciesStatus.upsStatus != this.usbConnectionCodeDict.INITIALISED) {
                    allUsbDevicesConnected = false;
                }
            }
        }

        systemStateNotificationHandler(systemState);

        if (!isServerReachable) {
            openEndPoint('/scanners/1', false, true);
        }
    }

    startScannerServer = () => {
        let id = this.props.device_id;
        this.setScannerServerBusy("Booting Scanner");
        let url = `/delayed_server/devices/` + id + '/start_scanner_server/';
        get_response(url)
            .then(response => {
                if (response.status !== 200) {
                    message.error("Failed to Start Scanner. Contact Admin!");
                    this.setScannerServerIdle();
                }
            })
            .catch(err => {
                this.setScannerServerIdle();
                console.log(err);
            })

    }

    stopScannerServer = () => {
        stopScannerServer(this.props.device_id);
    }

    ejectCassette = () => {
        store.dispatch(updateIsCassetteEjecting(true))
        const url = "/server/devices/" + this.props.device_id + "/eject/?background=false";
        get(url)
            .then(() => {
                store.dispatch(updateIsCassetteEjecting(false))
                message.success("Ejected successfully.");
                if((this.props.currentProcessIndex !== progressStage.LOAD_SLIDES && !(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response|| {}).scanning)) {
                    openEndPoint('/scanners/' + this.props.device_id)
                }
            })
            .catch(err => {
                store.dispatch(updateIsCassetteEjecting(false))
                error_manager("Eject Failed. Contact Morphle Support", err);
            });
    }

    handleOpenModal = () => {
        this.setState({modalVisible: true});
    };


    render() {
        const menu = (
            <Menu>
              <Menu.Item key="0">
                <Button onClick = {this.stopScannerServer}>
                    Stop Scanner <PoweroffOutlined />
                </Button>
              </Menu.Item>
            </Menu>
          );

        let isServerReachable = ((this.props.deviceStatus || {}).scanner_health || {}).server_up;
        let isMorpheusReachable = ((this.props.deviceStatus || {}).scanner_health || {}).device_name != undefined;
        
        let deviceType = (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response|| {})['deviceType']
        let isHemoLens = deviceType && deviceType.includes("HEMOLENS");

        let process_status = ((this.props.deviceStatus || {}).scanner_health || {}).process_status;
        let badges = [];
        for(var p in process_status){
            if(process_status[p][1] == 0){
                badges.push(<Badge status="default" />)
            }else if(process_status[p][1] == 1){
                badges.push(<Badge status="processing" />)
            }else{
                badges.push(<Badge status="error" />)
            }
        }
        
        let displayName = ((this.props.deviceStatus || {}).scanner_health || {}).device_name + " - Control Panel";
        if (this.props.type == specimenType.BLOOD){
            displayName = ((this.props.deviceStatus || {}).scanner_health || {}).device_name + " - Blood WorkFlow Panel";
        }
        let isFetchingAllPreviews = false;
        let currPreviewStatus = ((this.props.deviceStatus.scanner_health || {}).scanner_response|| {}).scanPreviewStatus;
        if (notNull(currPreviewStatus)) {
            for (const [key, value] of Object.entries(currPreviewStatus)) {
                if (value.previewOngoing) {
                    isFetchingAllPreviews = true;
                    break;
                }
            }
        }
        let runningAdvancedMode = ((this.props.deviceStatus.scanner_health || {}).scanner_response|| {})['runningAdvancedMode'];

        return (
            <div>
                <Row className="scanner-name-div" style={{background: '#ffffff', height: 70}}>
                    <Col span={1} style={{marginTop: 15, marginLeft: 10}}>
                        <Link to={"/scanner_settings/" + this.props.device_id + "/"}>
                            <SettingOutlined style={{color: '#000', fontSize: '35px'}}/>
                        </Link>
                    </Col>
                    <Col span={17} style={{marginTop: 15}}>
                        {hasPermissions([aclPermissions.live_mode]) &&
                            <Link className="scanner-user-controls" to={"/livemode/" + this.props.device_id + "/"}>
                                <Button onClick={this.onStartScanning} type='primary' className={"black-scanner-btn"}>
                                    Live Mode
                                </Button>
                            </Link>}
                    </Col>
                    <Col span={3} style={{marginTop: 15, textAlign: 'right'}}>
                        <Tooltip placement="bottom" title={this.props.deviceStatus?.scanner_health?.scanner_response?.ejected ? "Cassette is in Ejected state" : ""}>
                            <span>
                                <Button onClick={this.ejectCassette} type='primary' className={"black-scanner-btn"}
                                        disabled={(this.props.deviceStatus || {}).uiBusy || (this.props.deviceStatus || {}).scanner_health?.scanner_response?.scanning ||
                                            isFetchingAllPreviews || runningAdvancedMode ||
                                            this.props.deviceStatus?.scanner_health?.scanner_response?.ejected}>
                                    Eject Cassette
                                </Button>
                            </span>
                        </Tooltip>
                    </Col>
                    <Col span={1} style={{marginTop: 15, textAlign: 'right', marginLeft: 20}}>
                        <Button onClick={this.handleOpenModal} type='primary' className={"shutdown-scanner-btn"}>
                            Shut Down Scanner
                        </Button>
                    </Col>
                </Row>
                <Modal
                    title="Confirm Shutdown Scanner"
                    visible={this.state.modalVisible}
                    onCancel={() => this.setState({ modalVisible: false })}
                    footer={[
                        <Button
                            key="cancel"
                            onClick={() => this.setState({ modalVisible: false })}
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="confirm"
                            type={"danger"} ghost
                            onClick={() => {
                                this.stopScannerServer();
                                this.setState({ modalVisible: false });
                            }}
                        >
                            Confirm
                        </Button>,
                    ]}
                >
                    Are you sure you want to shutdown the scanner?
                </Modal>
            </div>

        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer[ownProps.device_id],
    };
};

export default connect(mapStateToProps)(ScannerTimeline);
